export default "__VITE_PUBLIC_ASSET__a69e7f4a__"